"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _Theme = _interopRequireDefault(require("../Theme"));
var _Icon = _interopRequireDefault(require("../Icon"));
var _constant = require("./constant");
var _Image = _interopRequireDefault(require("./Image.proptypes"));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var transitionEffect = (0, _styledComponents.css)(["transition:", ";&:hover{transform:", ";}"], function (props) {
  return props.hoverAnimation ? "all 1s ease-out" : null;
}, function (props) {
  return props.hoverAnimation ? "scale(1.1)" : null;
});
var LowResAnimation = (0, _styledComponents.css)(["filter:blur(8px);"]);
var Img = _styledComponents.default.img.withConfig({
  displayName: "Image__Img",
  componentId: "sc-x2qeul-0"
})(["width:100%;height:100%;object-fit:", ";", ";", ";border-radius:", ";", ""], function (props) {
  return props.centerFocus ? 'cover' : 'contain';
}, function (_ref) {
  var islowResolutionImageAvailable = _ref.islowResolutionImageAvailable;
  return islowResolutionImageAvailable && (0, _styledComponents.css)(["position:absolute;top:0;left:0;"]);
}, function (_ref2) {
  var lowResImage = _ref2.lowResImage,
    islowResolutionImageAvailable = _ref2.islowResolutionImageAvailable;
  return islowResolutionImageAvailable && lowResImage && LowResAnimation;
}, function (props) {
  return props.radius ? props.radius : '0px';
}, transitionEffect);
var ImgContainer = _styledComponents.default.div.withConfig({
  displayName: "Image__ImgContainer",
  componentId: "sc-x2qeul-1"
})(["background:", ";overflow:hidden;position:relative;", ";text-align:center;width:", ";height:", ";padding-bottom:", ";border-radius:", ";border:", ";"], function (props) {
  return props.placeHolderBackground ? props.theme.backgroundColor[props.placeHolderBackground] : props.theme.backgroundColor.tertiary;
}, function (_ref3) {
  var placeHolderIcon = _ref3.placeHolderIcon;
  return placeHolderIcon && (0, _styledComponents.css)(["text-align:center;"]);
}, function (props) {
  return props.width ? props.width : '100%';
}, function (props) {
  return props.height ? props.height : '0';
}, function (props) {
  return props.height ? '0' : '100%';
}, function (props) {
  return props.radius ? props.radius : '0px';
}, function (props) {
  return props.borderColor ? "1px solid ".concat(props.theme.colors[props.borderColor]) : null;
});
var StyledIcon = _styledComponents.default.div.withConfig({
  displayName: "Image__StyledIcon",
  componentId: "sc-x2qeul-2"
})(["position:relative;top:calc(50% - 10px);"]);
var getImageTypeIcon = function getImageTypeIcon(type) {
  return type in _constant.IMAGE_TYPE_ICONS ? _constant.IMAGE_TYPE_ICONS[type] : '';
};
var getIcon = function getIcon(icon) {
  return /*#__PURE__*/_react.default.createElement(StyledIcon, null, /*#__PURE__*/_react.default.createElement(_Icon.default, {
    icon: icon,
    color: "greyLighter",
    fontsize: "titleNormal",
    accessible: false
  }));
};
var ImageComponent = function ImageComponent(props) {
  var src = props.src,
    alt = props.alt,
    height = props.height,
    width = props.width,
    onLoad = props.onLoad,
    radius = props.radius,
    theme = props.theme,
    type = props.type,
    borderColor = props.borderColor,
    hoverAnimation = props.hoverAnimation,
    centerFocus = props.centerFocus,
    customProperties = props.customProperties,
    accessible = props.accessible,
    lowResolutionImageUrl = props.lowResolutionImageUrl,
    enableProgressiveImageLoading = props.enableProgressiveImageLoading,
    placeHolderBackground = props.placeHolderBackground,
    lazyLoadImage = props.lazyLoadImage;
  var tabIndex = !accessible ? '-1' : '0';
  var placeHolderIcon = getImageTypeIcon(type);
  var islowResolutionImageAvailable = enableProgressiveImageLoading && !!lowResolutionImageUrl;
  var getMain = function getMain() {
    return /*#__PURE__*/_react.default.createElement(ImgContainer, (0, _extends2.default)({
      height: height,
      width: width,
      onLoad: onLoad,
      radius: radius,
      placeHolderIcon: placeHolderIcon,
      borderColor: borderColor
    }, customProperties, {
      tabIndex: tabIndex,
      placeHolderBackground: placeHolderBackground,
      islowResolutionImageAvailable: islowResolutionImageAvailable
    }), placeHolderIcon && !src ? getIcon(placeHolderIcon) : null, src && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, islowResolutionImageAvailable && /*#__PURE__*/_react.default.createElement(Img, {
      src: lowResolutionImageUrl,
      alt: alt,
      height: height,
      width: width,
      centerFocus: centerFocus,
      islowResolutionImageAvailable: islowResolutionImageAvailable,
      lowResImage: true
    }), /*#__PURE__*/_react.default.createElement(Img, {
      src: src,
      alt: alt,
      height: height,
      width: width,
      onLoad: onLoad,
      radius: radius,
      centerFocus: centerFocus,
      hoverAnimation: hoverAnimation,
      loading: lazyLoadImage ? 'lazy' : undefined,
      islowResolutionImageAvailable: islowResolutionImageAvailable
    })));
  };
  return theme ? /*#__PURE__*/_react.default.createElement(_Theme.default, {
    theme: theme
  }, getMain()) : getMain();
};
ImageComponent.propTypes = _Image.default.PropTypes;
ImageComponent.defaultProps = _Image.default.DefaultProps;
var _default = ImageComponent;
exports.default = _default;